import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = Date;

export const useDefaultObservableDate = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectDate extends BehaviorSubject<CurrentType> {}
